import CloseButton from "@components/common/CloseButton";
import useAppContext from "@hooks/useAppContext";
import { useCallback } from "react";

const RaQToast = (): JSX.Element => {
  const appContext = useAppContext();
  const showToastMessage = appContext?.raqToast;
  const setShowToastMessage = appContext?.setRaqToast;
  const handleClose = useCallback(() => {
    if (setShowToastMessage) {
      setShowToastMessage(false);
    }
  }, []);
  return (
    <>
      {showToastMessage && (
        <div className="absolute bottom-[9rem] left-[1rem] z-[103] mb-4 flex h-11 w-[90%] justify-between rounded-3xl border-2 border-negative-100 bg-orange-10 desktop:bottom-0 desktop:left-[57.5rem] desktop:top-[4.5rem] desktop:w-[34rem]">
          <p className="my-auto ml-6 text-p13 font-medium text-black ">
            An error occurred while processing your request.
          </p>
          <div className="my-auto mr-2">
            <CloseButton onClick={handleClose} serverError={true} />
          </div>
        </div>
      )}
    </>
  );
};

export default RaQToast;
